import React from 'react';

// Fila de una hoja inferior del móvil: 48 px de alto, icono y texto de 15 px.
// tono: 'normal' | 'peligro' | 'principal'. descripcion: segunda línea gris.
// marcado: true/false enseña una marca a la derecha (opciones excluyentes).
export default function FilaHojaMovil({
  icono: Icono = null,
  texto,
  descripcion = null,
  onClick,
  tono = 'normal',
  disabled = false,
  marcado,
  derecha = null,
  ...resto
}) {
  const color = tono === 'peligro' ? 'text-red-600' : tono === 'principal' ? 'text-[#11704F]' : 'text-[#16221D]';
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`w-full min-h-[48px] flex items-center gap-3 px-5 py-2 text-left text-[15px] active:bg-gray-100 disabled:opacity-40 ${color}`}
      {...resto}
    >
      {Icono && <Icono className="w-5 h-5 shrink-0" />}
      {marcado !== undefined && (
        <span
          className={`w-5 h-5 shrink-0 rounded-full border-2 flex items-center justify-center ${
            marcado ? 'border-duetto-primary' : 'border-[#CBD3CF]'
          }`}
          aria-hidden="true"
        >
          {marcado && <span className="w-2.5 h-2.5 rounded-full bg-duetto-primary" />}
        </span>
      )}
      <span className="min-w-0 flex-1">
        <span className="block leading-snug break-words">{texto}</span>
        {descripcion && <span className="block mt-0.5 text-[13px] leading-snug text-[#5B6B64]">{descripcion}</span>}
      </span>
      {derecha}
    </button>
  );
}

// Separador con título opcional entre grupos de filas
export const SeparadorHojaMovil = ({ titulo = null }) => (
  titulo ? (
    <p className="px-5 pt-3 pb-1 text-xs font-bold uppercase tracking-wide text-[#8A9892] border-t border-[#EEF1EF]">{titulo}</p>
  ) : <div className="my-1 border-t border-[#EEF1EF]" />
);
